<template>
    <div class="overall-bg">
        <b-container fluid="xl">
            <b-row>
                <b-col>
                    <BacktoPage path="/locationMasterTableview"></BacktoPage>
                    <Headerlayout :headertext="EditID
                        ? t('assetManagement.locationMaster.edittitle')
                        : t('assetManagement.locationMaster.title')
                        " :contenttext="t('assetManagement.locationMaster.content')">
                    </Headerlayout>
                </b-col>
            </b-row>
            <b-row class="form-white-bg my-3">
                <b-form class="" @submit.prevent="submitForm">

                    <div class="details-card">
                        <b-row>
                            <b-col lg="6" md="6" sm="12" cols="12">
                                <b-row>
                                    <b-col lg="6" md="12" sm="8" cols="12">
                                        <div class="field">
                                            <TextInput id="ID" name="ID"
                                                :label="t('assetManagement.locationMaster.code')"
                                                :rules="{ required: true }" :disabled="true" placeholder=""
                                                v-model="isForm.Code" :required-icon="true" />
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col lg="6" md="12" sm="8" cols="12">
                                        <div class="field">
                                            <TextInput id="Name" name="Name"
                                                :label="t('assetManagement.locationMaster.name')"
                                                :rules="{ required: true }" placeholder="" v-model="isForm.Name"
                                                :required-icon="true" case="Capital" />
                                        </div>
                                    </b-col>
                                    <b-col lg="6" md="12" sm="8" cols="12">
                                        <div class="field">
                                            <TextInput :id="t('assetManagement.locationMaster.address')"
                                                :name="t('assetManagement.locationMaster.address')"
                                                :label="t('assetManagement.locationMaster.address')"
                                                :rules="{ required: true }" placeholder="" v-model="isForm.Name"
                                                :required-icon="true" case="Capital" />
                                        </div>
                                    </b-col>
                                </b-row>


                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col lg="3" md="3" sm="8" cols="12">
                                <div class="field">
                                    <TextInput :id="t('assetManagement.locationMaster.Building')"
                                        :name="t('assetManagement.locationMaster.Building')"
                                        :label="t('assetManagement.locationMaster.Building')"
                                        :rules="{ required: true, email: true }" placeholder="" v-model="isForm.Email"
                                        :required-icon="true" case="Lower" />
                                </div>
                            </b-col>
                            <b-col lg="3" md="3" sm="8" cols="12">
                                <div class="field">
                                    <TextInput :id="t('assetManagement.locationMaster.Floor')"
                                        :name="t('assetManagement.locationMaster.Floor')"
                                        :label="t('assetManagement.locationMaster.Floor')"
                                        :rules="{ required: true, email: true }" placeholder="" v-model="isForm.Email"
                                        :required-icon="true" case="Lower" />
                                </div>
                            </b-col><b-col lg="3" md="3" sm="8" cols="12">
                                <div class="field">
                                    <TextInput :id="t('assetManagement.locationMaster.Room')"
                                        :name="t('assetManagement.locationMaster.Room')"
                                        :label="t('assetManagement.locationMaster.Room')"
                                        :rules="{ required: true, email: true }" placeholder="" v-model="isForm.Email"
                                        :required-icon="true" case="Lower" />
                                </div>
                            </b-col>
                            <b-col lg="3" md="3" sm="8" cols="12">
                                <div class="field">
                                    <CustomTextarea name="Additional terms"
                                        :label="t('assetManagement.locationMaster.SpecificLocationDetails')"
                                        :rules="{ required: false }" id="Additional terms"
                                        v-model="isForm.AdditionalTerms" />
                                </div>
                            </b-col>

                        </b-row>
                    </div>
                    <b-row class="py-3">


                        <b-col lg="6" md="6" sm="12" cols="12">


                            <div class="mt-1">
                                <!-- <Tax v-model="objtaxdatadetails" /> -->

                                <b-row>
                                    <b-col>
                                        <h6 class="compo-heading">{{
                                            t('assetManagement.locationMaster.environmentalDetails') }}</h6>
                                    </b-col>
                                </b-row>
                                <div class="details-card">
                                    <b-row>
                                        <b-col lg="6" md="6" sm="12" cols="12">
                                            <div class="field">
                                                <TextInput name="Vattinno" id="Vattinno"
                                                    :label="t('assetManagement.locationMaster.Temperature')"
                                                    v-model="objtaxdatadetails.VATNo" />
                                            </div>
                                        </b-col>
                                        <b-col lg="6" md="6" sm="12" cols="12">
                                            <div class="field">
                                                <TextInput name="Servicetaxregno" id="Servicetaxregno"
                                                    :label="t('assetManagement.locationMaster.Humidity')"
                                                    v-model="objtaxdatadetails.ServiceTaxNo" />
                                            </div>
                                        </b-col>
                                        <b-col lg="6" md="6" sm="12" cols="12">
                                            <div class="field">
                                                <TextInput name="Excercisecode" id="Excercisecode"
                                                    :label="t('assetManagement.locationMaster.LastEnvironmentCheckDate')"
                                                    v-model="objtaxdatadetails.ExciseCode" />
                                            </div>
                                        </b-col>
                                        <b-col lg="6" md="6" sm="12" cols="12">
                                            <div class="field">
                                                <TextInput name="Incometaxpan" id="Incometaxpan"
                                                    :label="t('assetManagement.locationMaster.AccessControlType')"
                                                    v-model="objtaxdatadetails.IncomeTaxNo"
                                                    :rules="{ alphanumeric: true, Pannumber: true }" />
                                            </div>
                                        </b-col>
                                        <b-col lg="6" md="6" sm="12" cols="12">
                                            <div class="field">
                                                <TextInput name="Druglicence" id="Druglicence"
                                                    :label="t('assetManagement.locationMaster.EnvironmentalConditions')"
                                                    v-model="objtaxdatadetails.DrugLicence" />
                                            </div>
                                        </b-col>

                                        <b-col lg="6" md="6" sm="12" cols="12">
                                            <div class="mt-4 d-flex gap-4">
                                                <div>
                                                    <RadioButton v-model="isForm.DeliveryTermsId" inputId="ingredient1"
                                                        name="pizza" :value="1" />
                                                    <label for="ingredient1" class="ms-2">
                                                        yes
                                                    </label>
                                                </div>
                                                <div>
                                                    <RadioButton v-model="isForm.DeliveryTermsId" inputId="ingredient1"
                                                        name="pizza" :value="0" />
                                                    <label for="ingredient1" class="ms-2">
                                                        No
                                                    </label>
                                                </div>
                                            </div>
                                        </b-col>

                                    </b-row>
                                </div>
                            </div>

                        </b-col>
                        <b-col lg="6" md="6" sm="12" cols="12">
                            <div class="mt-1">
                                <!-- <Tax v-model="objtaxdatadetails" /> -->

                                <b-row>
                                    <b-col>
                                        <h6 class="compo-heading">{{
                                            t('assetManagement.locationMaster.contactdetails') }}</h6>
                                    </b-col>
                                </b-row>
                                <div class="details-card">
                                    <b-row>
                                        <b-col lg="6" md="6" sm="12" cols="12">
                                            <div class="field">
                                                <TextInput name="Vattinno" id="Vattinno"
                                                    :label="t('assetManagement.locationMaster.contactperson')"
                                                    v-model="objtaxdatadetails.VATNo" />
                                            </div>
                                        </b-col>
                                        <b-col lg="6" md="6" sm="12" cols="12">
                                            <div class="field">
                                                <TextInput name="Servicetaxregno" id="Servicetaxregno"
                                                    :label="t('assetManagement.locationMaster.contactPhone')"
                                                    v-model="objtaxdatadetails.ServiceTaxNo" />
                                            </div>
                                        </b-col>
                                        <b-col lg="6" md="6" sm="12" cols="12">
                                            <div class="field">
                                                <TextInput name="Excercisecode" id="Excercisecode"
                                                    :label="t('assetManagement.locationMaster.contactEmail')"
                                                    v-model="objtaxdatadetails.ExciseCode" />
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <div class="d-flex flex-row-reverse mt-5">
                            <Footer @cancel="routers.back(), IsClear()" :cancelhide="false" :label="label" />
                            <IsCreateSuccessully />
                        </div>
                    </b-row>
                </b-form>
            </b-row>
        </b-container>
    </div>
    <contactDetailsMappingPopup v-model:trigger="StatusVisible" v-if="StatusVisible" @update:modelValue="ContactDetails"
        v-model:selected-item="editItems" @close="StatusVisible = false" />
    <createdsuccessfully :visible="visible" @ok="closetrigger()" />
    <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
    <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
    <PaymentCreation v-model:trigger="DialogShow.PaymentTerms" v-if="DialogShow.PaymentTerms"
        @load="PaymentTermsServicedd(), (DialogShow.PaymentTerms = false)" @close="DialogShow.PaymentTerms = false"
        :OperationID="ObjOperationId" :EntityId="EntityIds.PaymentTerms" />
    <DeliveryTermsCreation v-model:trigger="DialogShow.DeliveryTerms" v-if="DialogShow.DeliveryTerms"
        @load="LoadDeliveryTerms(), (DialogShow.DeliveryTerms = false)" @close="DialogShow.DeliveryTerms = false"
        :OperationID="ObjOperationId" :EntityId="EntityIds.DeliveryTerms" />
    <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive } from "vue";
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import Cancel from "../../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../../components/GeneralButtons/SaveButton.vue";
import AddressDetails from "../../../../../../../modules/Inventory/components/MasterCreation/AddressDetails.vue";
import ContactDetails from "../../../../../../../modules/Inventory/components/MastersforInventory/contactdetails.vue";
import Tax from "../../../../../../../modules/Inventory/components/MasterCreation/Tax.vue";
import PaymentTerms from "../../../../../../../modules/Inventory/components/MasterCreation/PaymentTerms.vue";
import BankInformation from "../../../../../../../modules/Inventory/components/MasterCreation/BankInformation.vue";
import FileUpload from "../../../../../../../modules/Inventory/components/MasterCreation/FileUpload.vue";
import service from "../../../../../../../modules/Inventory/Service/SupplierMaster";
import CustomDropdown from "../../../../../../../components/FormComponents/Dropdown.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";
import { resolve } from "path";
import TextInput from "../../../../../../../components/FormComponents/TextInput.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import createdsuccessfully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import { clear } from "console";
import common from "../../../../../../../modules/Inventory/Service/CommonService";
import DeliveryTermsService from "../../../../../../../modules/Inventory/Service/DeliveryTermsService";
import OtherTermsService from "../../../../../../../modules/Inventory/Service/OtherTermsService";
// import FileUpload from 'primevue/fileupload';
import cancel from "../../../../../../../components/GeneralButtons/CancelButtton.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import contactDetailsMappingPopup from "../../../../../../../modules/Inventory/components/MasterCreation/contactDetailsMappingPopup.vue";
import SupplierContactDetailsService from "../../../../../../../modules/Inventory/Service/SupplierContactDetailsService";
import CustomTextarea from "../../../../../../../components/FormComponents/TextArea.vue";
import PaymentCreation from "../../../../../../../modules/Inventory/pages/Masters/Supplier/PaymentTerms/PaymentTermsCreation.vue";
import DeliveryTermsCreation from "../../../../../../../modules/Inventory/pages/Masters/Supplier/DeliveryTerms/DeliveryTermscreation.vue";
import MastersService from "../../../../../../../modules/Inventory/Service/MastersService";
import { checkPermission } from "../../../../../../../modules/Inventory/Service/AccessControl";
import { useToast } from "primevue/usetoast";
import commonservice from "../../../../../../../modules/Inventory/Service/StoreService";
import SupplierBranchMapping from "../../../../../../../modules/Inventory/Service/SupplierBranchMappingService";
import MultiSelectDropDown from "../../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import { setupHistoryManagement } from "../../../../../../../modules/Inventory/Service/HistoryManage";

export default defineComponent({
    props: {
        selectedItem: {
            type: Object,
            Default: () => { },
        },
        showButton: {
            type: Boolean,
            Required: true,
        },
    },
    components: {
        AlreadyExist,
        BacktoPage,
        Headerlayout,
        Cancel,
        Save,
        AddressDetails,
        ContactDetails,
        Tax,
        PaymentTerms,
        BankInformation,
        FileUpload,
        CustomDropdown,
        TextInput,
        Footer,
        createdsuccessfully,
        UpdatedSuccessfully,
        Loader,
        contactDetailsMappingPopup,
        CustomTextarea,
        PaymentCreation,
        DeliveryTermsCreation,
        MultiSelectDropDown,
    },

    setup(props, { emit }) {
        let session: any = localStorage.getItem("UsersData");
        const toast = useToast();
        session = JSON.parse(session);
        let HospitalId = Number(session.OrganizationId);
        let BranchId = Number(session.BranchId);
        let UserId = Number(session.UserId);
        let Entitydata = ref();
        Entitydata.value = localStorage.getItem("EntityData");
        Entitydata.value = JSON.parse(Entitydata.value);
        let FileNames = ref();
        const StatusVisible = ref(false);

        const visible = ref(false);
        const updatepop = ref(false);
        const alreadyexistpop = ref(false);
        const { t } = useI18n();
        const label = ref(t("btn.save"));
        const editItems = ref();

        const { handleSubmit, errors, resetForm, resetField } = useForm();
        let loading = ref(false);
        const routers = useRouter();
        const router = useRoute();
        const UpdateId = router.query;
        const model: any = ref(props.selectedItem);
        const EditID = router.query.Id;
        const OperationId: any = Number(router.query.OperationId);

        let supcategory = ref();
        let removecontact: any = ref([]);
        let contactlist: any = ref([]);
        let updateContact: any = ref([]);
        let createContact: any = ref([]);
        const successpop = ref(false);
        let isSubmitCalled = false;
        let paymenttermsdd = ref();
        let OptionDeliveryTerms = ref();
        let BranchData = ref([]);
        let selectedBranchId: any = [];
        const insert_contactdetails = ref({
            Id: 0,
            SupplierId: 0,
            ContactPerson: "",
            ContactDesignation: "",
            Phone: "",
            Email: "",
            Web: "",
            LaneLine: "",
            Fax: "",
            index: 0,
        });

        const objcontactdetails = ref({
            ContactPerson: "",
            ContactDesignation: "",
            Phone: "",
            Email: "",
            Web: "",
        });

        const objdatabankdetails = ref({
            BankName: "",
            BankAcNo: "",
            ReBankAcNo: "",
            BankBranch: "",
            IFSC: "",
        });

        const objaddressdetails = ref({
            StreetName: "",
            Landmark: "",
            Address: "",
            City: 0,
            State: 0,
            Country: 0,
            Pin: "",
        });

        const objtaxdatadetails = ref({
            VATNo: "",
            ServiceTaxNo: "",
            ExciseCode: "",
            IncomeTaxNo: "",
            GST: "",
            MSME: "",
            RTGSCODE: "",
            DrugLicence: "",
        });

        const objdatapaymentsterms = ref({
            PayTermsId: 0,
            CreditPeriod: 0,
            DateOfAssociation: null,
            DiscountPer: 0,
        });

        function closetrigger() {
            visible.value = false;
            updatepop.value = false;
            //routers.back();
            setupHistoryManagement(routers, 2);

        }

        const isForm = ref({
            CreatedAt: "",
            CreatedBy: 0,
            ModifiedAt: "",
            ModifiedBy: 0,
            Id: 0,
            Code: "",
            Name: "",
            Tds: "",
            Note: "",
            HospitalId: 0,
            BranchId: 0,
            AccountNo: 0,
            Village: 0,
            SupplierCategory: ref(),
            DeliveryTermsId: 0,
            OtherTermsId: 0,
            EntityId: 0,
            EntityOperationId: 0,
            AdditionalTerms: "",
            Reference: "",
            Email: "",
        });
        const SupplierBranchForm = ref({
            IsModified: true,
            IsDeleted: true,
            IsActive: true,
            CreatedAt: "",
            ModifiedAt: "",
            CreatedBy: 0,
            ModifiedBy: 0,
            CreatedByName: "string",
            EntityId: 0,
            EntityOperationId: 0,
            HospitalId: 0,
            BranchId: 0,
            Id: 0,
            SupplierId: 0,
        });
        let multipleBranchId: any = ref([]);
        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }
        let Rights = ref({
            Create: false,
            Update: false,
            Read: false,
            Delete: false,
        });
        const copyRights = JSON.parse(JSON.stringify(Rights.value));
        let ObjOperationId = ref({
            CreateId: 0,
            UpdateId: 0,
            ReadId: 0,
            DeleteId: 0,
        });
        const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
        let DialogShow = ref({
            PaymentTerms: false,
            DeliveryTerms: false,
        });
        let EntityIds = ref({
            PaymentTerms: 116,
            DeliveryTerms: 117,
        });
        onMounted(() => {
            document.addEventListener("keydown", onKeyUp);
            if (EditID != "" && EditID != null) {
                IsEdit();
            } else {
                GetCode();
            }
            suppliercategorydd();
            PaymentTermsServicedd();
            LoadDeliveryTerms();
            // LoadOtherTerms();
            LoadBranch();
        });
        async function LoadBranch() {
            debugger;
            let result = await commonservice.getBranch(session.OrganizationId);
            BranchData.value = result["result"]
                .map((item) => {
                    item.name = item.Name;
                    item.value = item.ID;
                    return item;
                })
                .filter((items) => items.OrganizationId == HospitalId);
            debugger;
        }

        async function IsEdit() {
            loading.value = true;
            try {
                debugger;
                label.value = "Update";
                let response = await service.EditData(EditID);
                const data1 = response["result"][0];

                Object.keys(isForm.value).forEach((key) => {
                    if (data1[key]) isForm.value[key] = data1[key];
                });

                Object.keys(objaddressdetails.value).forEach((key) => {
                    if (data1[key]) objaddressdetails.value[key] = data1[key];
                });

                Object.keys(objdatabankdetails.value).forEach((key) => {
                    if (data1[key]) objdatabankdetails.value[key] = data1[key];
                });

                Object.keys(objcontactdetails.value).forEach((key) => {
                    if (data1[key]) objcontactdetails.value[key] = data1[key];
                });

                Object.keys(objtaxdatadetails.value).forEach((key) => {
                    if (data1[key]) objtaxdatadetails.value[key] = data1[key];
                });

                Object.keys(objdatapaymentsterms.value).forEach((key) => {
                    if (key == "DateOfAssociation") {
                        const regex = /^\d{2}-\d{2}-\d{4}$/;
                        let dateOfAssociation: any;
                        if (data1[key]) {
                            dateOfAssociation = moment(data1[key]).format("DD-MM-YYYY");
                        }
                        data1[key] = dateOfAssociation;
                    } else {
                        if (data1[key]) objdatapaymentsterms.value[key] = data1[key];
                    }
                });

                const contactdata_response = await SupplierContactDetailsService.Edit(
                    EditID
                );
                contactlist.value = contactdata_response["result"];
                const ImgResponse = await service.GetFilesBySupplierId(EditID);
                FileNames.value = ImgResponse["result"];
                console.log("File Names", FileNames.value);
                const SupplierBranch = await SupplierBranchMapping.getById(EditID);
                for (let item of SupplierBranch["result"]) {
                    multipleBranchId.value.push(item["BranchId"]);
                    selectedBranchId.push(item);
                }
                loading.value = false;
            } catch (error) {
                loading.value = false;
                console.log(error);
            }
        }

        async function PaymentTermsServicedd() {
            try {
                const dataresponse = await service.getpaymentstermsdd();

                console.log(dataresponse["result"]);

                paymenttermsdd.value = dataresponse["result"]
                    .filter(
                        (items) =>
                            items.HospitalId == HospitalId
                    )
                    .map((item) => {
                        item.name = item.PaymentTermsDesc;
                        item.value = item.Id;
                        return item;
                    });
            } catch (error) {
                alert(error);
            }
        }

        //Load Delivery Terms

        async function LoadDeliveryTerms() {
            try {
                const dataresponse = await DeliveryTermsService.getdata();

                console.log(dataresponse["result"]);

                OptionDeliveryTerms.value = dataresponse["result"]
                    .filter(
                        (i1) =>
                            i1.IsActive == true &&
                            i1.HospitalId == HospitalId
                    )
                    .map((item) => {
                        item.name = item.DeliTermsDesc;
                        item.value = item.Id;
                        return item;
                    });
            } catch (error) {
                alert(error);
            }
        }

        //Load Other Terms
        let OptionOtherTerms = ref();

        async function LoadOtherTerms() {
            try {
                const dataresponse = await OtherTermsService.getdata();

                console.log(dataresponse["result"]);

                OptionOtherTerms.value = dataresponse["result"]
                    .filter(
                        (i1) =>
                            i1.IsActive == true &&
                            i1.HospitalId == HospitalId
                    )
                    .map((item) => {
                        item.name = item.OtherTermDesc;
                        item.value = item.Id;
                        return item;
                    });
            } catch (error) {
                alert(error);
            }
        }

        async function suppliercategorydd() {
            try {
                const dataresponse = await service.getdata();

                console.log(dataresponse);

                supcategory.value = dataresponse["result"].map((item: any) => {
                    item.name = item.SupplierCatName;
                    item.value = item.Id;
                    return item;
                });
            } catch (error) {
                console.log(error);
            }
        }

        async function GetCode() {
            debugger;
            let data = {
                //FormId: 1021,
                EntityId: Entitydata.value.EntityId,
                HospitalId: HospitalId,
                BranchId: BranchId,
                StoreId: 0
            };
            let result: any = await common.getCodeTemplate(data);
            console.log(result);

            isForm.value.Code = result;
        }

        function isEditdetails(data, index) {
            try {
                data.index = index;
                editItems.value = data;

                // Editmodel.value = false;
                debugger;
                StatusVisible.value = true;
            } catch (error) {
                alert(error);
            }
        }

        function contactRemoveTagging(index) {
            const mention = contactlist.value.findIndex((item) => item === index);
            contactlist.value.splice(mention, 1);
            if (index["Id"] != 0) {
                const newObj = {
                    id: index["Id"],
                };
                removecontact.value.push(newObj);
            }
        }

        function ContactDetails(data) {
            if (data.index == 0) {
                contactlist.value.push(data);
            } else {
                Object.assign(contactlist.value[data.index - 1], data);
            }
        }

        // submit function

        const submitForm = handleSubmit(async (values) => {
            debugger;
            loading.value = true;
            debugger;
            let contactResult: any;
            let contactResponse: any;
            let BranchResponse: any;
            let EmailId = isForm.value.Email;
            let SupplierBranchobject: any = ref([]);
            isForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            isForm.value.ModifiedAt = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );
            isForm.value.BranchId = BranchId;
            isForm.value.HospitalId = HospitalId;
            isForm.value.ModifiedBy = UserId;
            isForm.value.CreatedBy = UserId;
            isForm.value.EntityId = Number(Entitydata.value.EntityId);
            isForm.value.EntityOperationId = OperationId;
            objdatapaymentsterms.value.PayTermsId =
                objdatapaymentsterms.value.PayTermsId == null
                    ? 0
                    : objdatapaymentsterms.value.PayTermsId;

            isForm.value.DeliveryTermsId =
                isForm.value.DeliveryTermsId == null
                    ? 0
                    : isForm.value.DeliveryTermsId;
            SupplierBranchForm.value.CreatedAt = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );
            SupplierBranchForm.value.ModifiedAt = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );
            SupplierBranchForm.value.ModifiedBy = UserId;
            SupplierBranchForm.value.CreatedBy = UserId;
            if (contactlist.length != 0) {
                contactResult = contactlist.value.map(({ index, ...rest }) => rest);
                contactResult.map((item) => {
                    (item.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                        (item.CreatedBy = 0),
                        (item.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                        (item.ModifiedBy = 0),
                        (item.HospitalId = HospitalId),
                        (item.BranchId = BranchId);
                });
            }
            for (let item of multipleBranchId.value) {
                const newSupplierBranchForm = { ...SupplierBranchForm.value };
                newSupplierBranchForm.BranchId = item;
                SupplierBranchobject.value.push(newSupplierBranchForm);
            }
            if (
                objdatabankdetails.value.BankAcNo == objdatabankdetails.value.ReBankAcNo
            ) {
                let dateOfAssociation: any;
                if (objdatapaymentsterms.value.DateOfAssociation) {
                    dateOfAssociation = moment(
                        objdatapaymentsterms.value.DateOfAssociation,
                        "DD-MM-YYYY"
                    ).format("YYYY-MM-DD");
                }
                objdatapaymentsterms.value.DateOfAssociation = dateOfAssociation;
                debugger;
                if (isForm.value.Id != 0) {
                    const data_insert = Object.assign(
                        isForm.value,
                        objaddressdetails.value,
                        objdatabankdetails.value,
                        objtaxdatadetails.value,
                        objdatapaymentsterms.value,
                        objcontactdetails.value
                    );
                    data_insert.Email = EmailId;
                    try {
                        const data_response = await service.update(data_insert);
                        let message = data_response["ErrorInfo"].ErrorCode;
                        for (let j = 0; j < contactResult.length; j++) {
                            debugger;
                            const element = contactResult[j];
                            if (element.Id != 0) {
                                updateContact.value.push(element);
                            } else {
                                createContact.value.push(element);
                            }
                        }
                        if (updateContact.value.length != 0) {
                            contactResponse = await SupplierContactDetailsService.Update(
                                updateContact.value
                            );
                            message = contactResponse["ErrorInfo"].ErrorCode;
                        }
                        if (createContact.value.length != 0) {
                            createContact.value.map((item) => {
                                item.SupplierId = UpdateId.Id;
                            });
                            contactResponse = await SupplierContactDetailsService.insert(
                                createContact.value
                            );
                            message = contactResponse["ErrorInfo"].ErrorCode;
                        }
                        if (removecontact.value.length != 0) {
                            for (let i = 0; i < removecontact.value.length; i++) {
                                if (!removecontact.value[i].IsActive) {
                                    let result = await SupplierContactDetailsService.Delete(
                                        removecontact.value[i].id
                                    );
                                }
                            }
                        }
                        if (SupplierBranchobject.value.length >= 1) {
                            SupplierBranchobject.value.map((item) => {
                                item.SupplierId = UpdateId.Id;
                            });
                            BranchResponse = await SupplierBranchMapping.insert(
                                SupplierBranchobject.value
                            );
                            message = BranchResponse["ErrorInfo"].ErrorCode;
                        }
                        let filteredBranchId = selectedBranchId.filter(
                            (item) => !multipleBranchId.value.includes(item["BranchId"])
                        );
                        for (let item of filteredBranchId) {
                            let result = await SupplierBranchMapping.delete(item["Id"]);
                        }
                        loading.value = false;
                        debugger;
                        if (data_response["result"] == "Already" && message == null) {
                            alreadyexistpop.value = true;
                        } else if (message == null) {
                            FileInsert(isForm.value.Id);
                            updatepop.value = true;
                        }
                        // IsClear();
                    } catch (error) {
                        loading.value = false;
                        console.log(error);
                    }
                } else {
                    const data_insert = Object.assign(
                        isForm.value,
                        objaddressdetails.value,
                        objdatabankdetails.value,
                        objtaxdatadetails.value,
                        objdatapaymentsterms.value,
                        objcontactdetails.value
                    );
                    debugger;
                    data_insert.Email = EmailId;
                    try {
                        const data_response = await service.insert(data_insert);
                        console.log(data_response);
                        let SupplierId = data_response["result"];
                        let message = data_response["ErrorInfo"].ErrorCode;
                        let SupId = data_response["result"];
                        loading.value = false;
                        if (contactResult.length != 0) {
                            contactResult.map((item) => {
                                item.SupplierId = SupplierId;
                            });
                            contactResponse = await SupplierContactDetailsService.insert(
                                contactResult
                            );
                            message = contactResponse["ErrorInfo"].ErrorCode;
                        }
                        if (SupplierBranchobject.value.length >= 1) {
                            SupplierBranchobject.value.map((item) => {
                                item.SupplierId = SupplierId;
                            });
                            BranchResponse = await SupplierBranchMapping.insert(
                                SupplierBranchobject.value
                            );
                            message = BranchResponse["ErrorInfo"].ErrorCode;
                        }
                        if (data_response["result"] == "Already" && message == null) {
                            alreadyexistpop.value = true;
                        } else if (message == null) {
                            FileInsert(SupId);
                            visible.value = true;
                            loading.value = false;
                        }
                    } catch (error) {
                        loading.value = false;
                        console.log(error);
                    }
                }
            } else {
                console.log("check bank account number condition");
            }
        });

        function FileNameData(data) {
            debugger;
            FileNames = data;
            console.log(FileNames);
        }

        const ImgObj = ref({
            CreatedAt: "2023-02-03T11:57:55.028Z",
            ModifiedAt: "2023-02-03T11:57:55.028Z",
            CreatedBy: 0,
            ModifiedBy: 0,
            Id: 0,
            SupplierId: 0,
            ImageFile: "",
        });

        async function FileInsert(SupplierId) {
            debugger;

            for (let i = 0; i < FileNames.value.length; i++) {
                console.log(FileNames.value[i]);
                ImgObj.value.ImageFile = FileNames.value[i];
                ImgObj.value.SupplierId = Number(SupplierId);
                ImgObj.value.Id = FileNames.value[i].Id;
                const data_response = await service.Fileinsert(ImgObj.value);
                let msg = data_response["ErrorInfo"].ErrorCode;
            }
        }

        function alreadyclosetrigger() {
            debugger;
            alreadyexistpop.value = false;
            isForm.value.Name = "";
            //showDialog.value = true
        }

        const copydataModel1 = JSON.parse(JSON.stringify(isForm.value));
        const copydataModel2 = JSON.parse(JSON.stringify(objaddressdetails.value));
        const copydataModel3 = JSON.parse(JSON.stringify(objdatabankdetails.value));
        const copydataModel4 = JSON.parse(JSON.stringify(objtaxdatadetails.value));
        const copydataModel5 = JSON.parse(
            JSON.stringify(objdatapaymentsterms.value)
        );
        const copydataModel6 = JSON.parse(JSON.stringify(objcontactdetails.value));
        const copyinsert_contactdetails = JSON.parse(
            JSON.stringify(insert_contactdetails.value)
        );

        const IsClear = () => {
            Object.assign(isForm.value, copydataModel1);
            Object.assign(objaddressdetails.value, copydataModel2);
            Object.assign(objdatabankdetails.value, copydataModel3);
            Object.assign(objtaxdatadetails.value, copydataModel4);
            Object.assign(objdatapaymentsterms.value, copydataModel5);
            Object.assign(objcontactdetails.value, copydataModel6);
            Object.assign(insert_contactdetails.value, copyinsert_contactdetails);

            emit("update:selectedItem", undefined);
            emit("close");
        };

        function onKeyUp(event: KeyboardEvent) {
            debugger;

            if (event.altKey && event.key == "s") {
                if (!isSubmitCalled) {
                    isSubmitCalled = true;
                    submitForm();
                }
            } else if (
                (event.altKey && event.key == "c") ||
                (event.key == "Escape" &&
                    successpop.value == false &&
                    updatepop.value == false &&
                    alreadyexistpop.value == false)
            ) {
                IsClear();
            } else if (
                event.key == "Escape" &&
                (successpop.value == true || updatepop.value == true)
            ) {
                closetrigger();
            } else if (event.key == "Escape" && alreadyexistpop.value == true) {
                alreadyclosetrigger();
            }
        }

        const isCreate = () => {
            StatusVisible.value = true;
        };
        async function FunctionRights(EntityId, FieldType) {
            debugger;
            Object.assign(Rights.value, copyRights);
            Object.assign(ObjOperationId.value, copyObjOperationId);
            const response = await MastersService.CheckMenuRights(
                EntityId,
                rolesData.RoleId
            );
            console.log(response["result"]);

            for (let i = 0; i < response["result"].length; i++) {
                const operation = response["result"][i];
                if (operation.OperationName === "Create") {
                    ObjOperationId.value.CreateId = operation.OperationID;
                    Rights.value.Create = operation.IsActive;
                } else if (operation.OperationName === "Update") {
                    ObjOperationId.value.UpdateId = operation.OperationID;
                    Rights.value.Update = operation.IsActive;
                } else if (operation.OperationName === "Read") {
                    ObjOperationId.value.ReadId = operation.OperationID;
                    Rights.value.Read = operation.IsActive;
                } else if (operation.OperationName === "Delete") {
                    ObjOperationId.value.DeleteId = operation.OperationID;
                    Rights.value.Delete = operation.IsActive;
                }
            }
            let permissionResult: any = checkPermission(Rights, "Add");
            if (permissionResult.hasPermission) {
                DialogShow.value[FieldType] = true;
            } else {
                toast.add(permissionResult.toast);
                return;
            }
        }
        return {
            t,
            routers,
            EditID,
            ObjOperationId,
            EntityIds,
            DialogShow,
            FunctionRights,
            isCreate,
            ContactDetails,
            editItems,
            StatusVisible,
            alreadyclosetrigger,
            alreadyexistpop,
            suppliercategorydd,
            isForm,
            objaddressdetails,
            objdatabankdetails,
            objtaxdatadetails,
            paymenttermsdd,
            objdatapaymentsterms,
            objcontactdetails,
            submitForm,
            supcategory,
            loading,
            visible,
            updatepop,
            closetrigger,
            IsEdit,
            IsClear,
            LoadDeliveryTerms,
            LoadOtherTerms,
            OptionDeliveryTerms,
            OptionOtherTerms,

            isEditdetails,
            contactRemoveTagging,
            label,
            FileNameData,
            PaymentTermsServicedd,
            FileNames,
            contactlist,
            BranchData,
            multipleBranchId,
            imageData: {
                src: "",
                alt: "example image",
            },
        };
    },
});
</script>
